import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';

const DepartmentCreate = () => {
  const [name, setName] = useState('');
  const [color, setColor] = useState('#000000');
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = (e) => {
    e.preventDefault();
    setLoading(true);
    setError(null);
    fetch(`${process.env.REACT_APP_API_URL}/api/departments`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${localStorage.getItem('token')}`,
      },
      body: JSON.stringify({ name, color }),
    })
      .then(res => {
        setLoading(false);
        if (res.ok) {
          navigate('/departments');
        } else {
          res.json().then(data => setError(data.message || 'Failed to create department'));
        }
      })
      .catch(() => {
        setLoading(false);
        setError('Failed to create department');
      });
  };

  return (
    <div className="container-fluid users-page" style={{ width: '70%' }}>
      <div className="breadcrumb-row" >
        <span className="breadcrumb-main" onClick={() => navigate('/dashboard')} style={{ cursor: 'pointer', color: '#337ab7' }}>Dashboard</span>
        <span className="breadcrumb-sep">/</span>
        <span className="breadcrumb-users">Users</span>
        <span className="breadcrumb-sep">/</span>
        <span className="breadcrumb-staff">Staff</span>
        <span className="breadcrumb-sep">/</span>
        <span className="breadcrumb-departments">Departments</span>
        <span className="breadcrumb-sep">/</span>
        <span className="breadcrumb-create">Create</span>
      </div>
      <form onSubmit={handleSubmit} style={{ maxWidth: '100%', backgroundColor: '#F8F9FA'}}>
        <label className='users-overview-title' style={{ margin: 16 }}>Create Department</label>

        <div className="form-group mb-3 col-6" style={{ gap: '40px', justifyContent: 'center', flexDirection: 'row', alignItems: 'center' }}>
          <span className='col-3 label-required' style={{ textAlign: 'right' }}>Name</span>
          <input
            type="text"
            className="form-control"
            value={name}
            onChange={e => setName(e.target.value)}
            required
          />
        </div>
        <div className="form-group mb-3 col-6" style={{ gap: '40px', justifyContent: 'center', flexDirection: 'row', alignItems: 'center' }}>
          <span className='col-3' style={{ textAlign: 'right' }}>Color</span>

          <input
            type="color"
            className="form-control"
            value={color}
            onChange={e => setColor(e.target.value)}
            style={{ height: 40, padding: 0, border: 'none', background: 'none' }}
          />
          <span style={{ marginLeft: 12 }}>{color}</span>

        </div>
        {error && <div className="alert alert-danger">{error}</div>}
        <div className='col-6' style={{ display: 'flex', width: '100%', justifyContent: 'flex-end', marginTop: 32, padding: 24  }}>
          <button className="btn btn-add-color" type="submit" disabled={loading} >
            {loading ? 'Saving...' : 'Create'}
          </button>
        </div>
      </form>
    </div>
  );
};

export default DepartmentCreate; 